// material
import ModernTable from '../components/ModernTable';
import { useTheme } from '@mui/material/styles';
import { Typography, Box, Chip, alpha } from '@mui/material';
import { fCurrency } from './utils/formatNumber';
import GroupIcon from '@mui/icons-material/Group';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ReceiptIcon from '@mui/icons-material/Receipt';

export default function GroupsSalesChart(props) {
  const theme = useTheme();
  const { data, endDate, startDate, machinesName } = props;
  const MyNewTitle = ({ text = 'Table Title', variant = 'h6' }) => (
    <Typography
      variant={variant}
      style={{ overflow: 'hidden', textOverflow: 'ellipsis', marginTop: '20px' }}
    >
      {`Sales By Group Table (${machinesName} from ${startDate.toShortFormat()} to  ${endDate.toShortFormat()})`}
    </Typography>
  );

  const columns = [
    {
      title: 'Group Name',
      field: 'name',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {rowData.name}
        </Typography>
      ),
    },
    {
      title: 'Total Sale',
      field: 'totalSale',
      render: (rowData) => (
        <Chip
          label={fCurrency(rowData.totalSale)}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.success.main, 0.12),
            color: theme.palette.success.dark,
            border: `1.5px solid ${alpha(theme.palette.success.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Total Tax',
      field: 'totalTax',
      render: (rowData) => (
        <Chip
          label={fCurrency(rowData.totalTax)}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.warning.main, 0.12),
            color: theme.palette.warning.dark,
            border: `1.5px solid ${alpha(theme.palette.warning.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Total Transactions',
      field: 'totalTrans',
      render: (rowData) => (
        <Chip
          icon={<ReceiptIcon sx={{ fontSize: 16 }} />}
          label={rowData.totalTrans ? rowData.totalTrans : 0}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.primary.main, 0.12),
            color: theme.palette.primary.dark,
            border: `1.5px solid ${alpha(theme.palette.primary.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.primary.dark,
            },
          }}
        />
      ),
    },
  ];

  return (
    <div>
      <ModernTable
        columns={columns}
        data={data}
        title={<MyNewTitle variant="h6" />}
        options={{
          actionsColumnIndex: -1,
          pageSize: 10,
          pageSizeOptions: [10, 20, 50, 100, 200],
        }}
      />
    </div>
  );
}
